<template>
  <b-button
    size="md"
    variant="link"
    :style="{ backgroundColor: '#08A762', color: '#151515' }"
    class="ml-3"
    @click="performAction"
  >
    <i class="fa fa-list" />
    Create report
  </b-button>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { OPTIMIZE_CREATING_REPORT_LOADER } from '@/const/LoadersNames'
import { openModal } from '@/services/Modal'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useUiStore } from '@/store/ui'

export default defineComponent({
  name: 'CreateReport',
  setup() {
    const accountStore = useAccountStore()
    const uiStore = useUiStore()
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const isStaff = computed(() => accountStore.isStaff)

    const performAction = () => {
      openModal('confirmWrap', {
        title: 'Optimize & Create Report?',
        message: isStaff.value
          ? 'This will create report and send it to client.'
          : 'You will be able to accept report and create labels at the next stage',
        okButtonText: 'Proceed',
        onConfirm: () => {
          uiStore.loaderShow({
            name: OPTIMIZE_CREATING_REPORT_LOADER,
            data: { progress: 0 },
          })
          assignmentSummaryStore.submitOptimize()
        },
      })
    }

    return {
      performAction,
    }
  },
})
</script>
